import { gettext } from '@eventbrite/i18n';
import { css } from 'emotion';
import React from 'react';
import Divider from '../../../divider/Divider';
import { useTheme } from '../../../theme-context';

interface ITicketReleaseHoldLine {
    clickAction: (_: any) => void;
}

const TicketReleaseHoldLine = ({
    clickAction,
}: ITicketReleaseHoldLine): React.ReactElement => {
    const { getFont } = useTheme();

    return (
        <div>
            <Divider />
            <div
                className={css({
                    padding: '16px 0 0 16px',
                })}
            >
                <a
                    className={css({
                        fontFamily: getFont('desktop/body/small/bold')
                            .fontFamily,
                        fontWeight: getFont('desktop/body/small/bold')
                            .fontWeight,
                        fontSize: getFont('desktop/body/small/bold').fontSize,
                    })}
                    href="#"
                    onClick={clickAction}
                >
                    {gettext('Release Hold')}
                </a>
            </div>
        </div>
    );
};

export default TicketReleaseHoldLine;
